import { defaultPalette } from './palette';
import { lightboxMessages, PALETTE_LABEL_KEY } from './messages';

// Returns a schema fragment to merge into a consumer block's schema.
// Shape:
//   {
//     fieldsetId: string,
//     fieldsetTitle: string (translated),
//     fields: string[],
//     properties: { [field]: SchemaField },
//   }
//
// Consumer pattern (in vilax ImageGallery Schema.js):
//   const lightboxFragment = lightboxSchemaFragment(intl);
//   return {
//     fieldsets: [
//       { id: 'default', title: ..., fields: ['columns', 'gap'] },
//       { id: lightboxFragment.fieldsetId,
//         title: lightboxFragment.fieldsetTitle,
//         fields: lightboxFragment.fields },
//     ],
//     properties: { columns: ..., gap: ..., ...lightboxFragment.properties },
//   };
export const lightboxSchemaFragment = (intl) => {
  const paletteChoices = defaultPalette.map((p) => [
    p.id,
    intl.formatMessage(
      PALETTE_LABEL_KEY[p.id] || {
        id: 'lightboxPaletteUnknown',
        defaultMessage: p.id,
      },
    ),
  ]);

  return {
    fieldsetId: 'lightbox',
    fieldsetTitle: intl.formatMessage(lightboxMessages.lightboxFieldsetTitle),
    fields: [
      'enable_lightbox',
      'lightbox_zoom',
      'lightbox_fullscreen',
      'lightbox_counter',
      'backdrop_palette',
      'backdrop_custom_color',
      'backdrop_custom_opacity',
    ],
    properties: {
      enable_lightbox: {
        title: intl.formatMessage(lightboxMessages.enableLightbox),
        type: 'boolean',
        default: true,
      },
      lightbox_zoom: {
        title: intl.formatMessage(lightboxMessages.lightboxZoom),
        type: 'boolean',
        default: true,
      },
      lightbox_fullscreen: {
        title: intl.formatMessage(lightboxMessages.lightboxFullscreen),
        type: 'boolean',
        default: true,
      },
      lightbox_counter: {
        title: intl.formatMessage(lightboxMessages.lightboxCounter),
        type: 'boolean',
        default: true,
      },
      // backdrop_palette default is null = "use tenant default" sentinel.
      // resolveBackdrop falls through to step 4 (config.settings.lightbox.defaultPaletteId)
      // when this field is null/undefined. See palette.js resolveBackdrop().
      backdrop_palette: {
        title: intl.formatMessage(lightboxMessages.backdropPaletteTitle),
        type: 'string',
        choices: paletteChoices,
        default: null,
      },
      backdrop_custom_color: {
        title: intl.formatMessage(lightboxMessages.backdropCustomColorTitle),
        type: 'string',
        widget: 'color',
        default: '#000000',
      },
      backdrop_custom_opacity: {
        title: intl.formatMessage(lightboxMessages.backdropCustomOpacityTitle),
        type: 'integer',
        minimum: 0,
        maximum: 100,
        default: 92,
      },
    },
  };
};
